import { createStore } from "vuex";

// Durata sessione in minuti
export const SESSION_EXPIRATION_MINUTES = 5;

const initialState = {
  isStarted: false,
  currentStep: 0,
  topicId: undefined,
  officeId: undefined,
  searchText: undefined,
  searched: false,
  resourceId: undefined,
  searchDirectFromUrl: false,
  erogationMode: "fis",
  numberOfReservations: 1,
  month: undefined,
  day: undefined,
  hour: undefined,
  slots: [],
  reservationId: undefined,
  reservationDate: undefined,
  serviceId: undefined,
  serviceSlotNumber: 1,
  identifyValues: [],
  detail: "",
  attributes: {},
  user: {},
  isRecapping: false,
  isEditing: false,
  modulePath: window?.drupalSettings?.modulePath,
  appRoute: window?.drupalSettings?.path?.currentPath
};

export const store = createStore({
  state() {
    let storedState = JSON.parse(
      window.sessionStorage.getItem("prenotazione_store")
    );
    let reservationDate = storedState?.reservationDate
      ? new Date(storedState.reservationDate)
      : undefined;
    if (reservationDate) {
      let diff = reservationDate ? (new Date() - reservationDate) / 60000 : 0;
      if (diff > SESSION_EXPIRATION_MINUTES) {
        storedState = initialState;
        window.sessionStorage.clear();
      }
    }

    const searchParams = new URLSearchParams(window.location.search);
    const searchTopicId = searchParams.get("topicId");
    const searchOfficeId = searchParams.get("officeId");
    const searchText = searchParams.get("searchText");
    const searchResourceId = searchParams.get("resourceId");
    const searchReservationId = searchParams.get("reservationId");
    const searchPaymentReservationId = searchParams.get("paymentReservationId");
    const searchDirectFromUrl = !!(searchParams.get("resourceId"));

    if (
      [0, 5].includes(storedState?.currentStep) &&
      !searchOfficeId &&
      !searchTopicId &&
      !searchText &&
      !searchResourceId &&
      !searchReservationId &&
      !searchPaymentReservationId &&
      !searchDirectFromUrl
    )storedState = initialState; // Reset if dirty

    if (searchOfficeId || searchTopicId || searchText || searchResourceId) {
      // If search params are present, reset the state
      storedState = initialState;
      storedState.currentStep = 0;
      storedState.searched = true;
      storedState.officeId = searchOfficeId || undefined;
      storedState.topicId = searchTopicId || undefined;
      storedState.searchText = searchText || undefined;
      storedState.resourceId = searchResourceId || undefined;
      storedState.searchDirectFromUrl = searchDirectFromUrl || undefined;
    }
    if (searchReservationId) {
      // If search params are present, reset the state
      storedState = initialState;
      storedState.searched = true;
      storedState.officeId = searchOfficeId || undefined;
      storedState.topicId = searchTopicId || undefined;
      storedState.searchText = searchText || undefined;
      storedState.resourceId = searchResourceId || undefined;
      storedState.currentStep = 5;
    }
    if (searchPaymentReservationId) {
      // If search params are present, reset the state
      storedState = initialState;
      storedState.searched = true;
      storedState.officeId = searchOfficeId || undefined;
      storedState.topicId = searchTopicId || undefined;
      storedState.searchText = searchText || undefined;
      storedState.resourceId = searchResourceId || undefined;
      storedState.currentStep = 6;
    }
    return {
      isStarted: storedState?.isStarted || initialState.isStarted,
      currentStep: storedState?.currentStep || initialState.currentStep,
      topicId: storedState?.topicId || initialState.topicId,
      officeId: storedState?.officeId || initialState.officeId,
      searchText: storedState?.searchText || initialState.searchText,
      searched: storedState?.searched || initialState.searched,
      resourceId: storedState?.resourceId || initialState.resourceId,
      searchDirectFromUrl: storedState?.searchDirectFromUrl || initialState.searchDirectFromUrl,
      erogationMode: storedState?.erogationMode || initialState.erogationMode,
      numberOfReservations:
        storedState?.numberOfReservations || initialState.numberOfReservations,
      month: storedState?.month || initialState.month,
      day: storedState?.day || initialState.day,
      hour: storedState?.hour || initialState.hour,
      slots: storedState?.slots || initialState.slots,
      reservationId: storedState?.reservationId || initialState.reservationId,
      reservationDate:
        storedState?.reservationDate || initialState.reservationDate,
      serviceId: storedState?.serviceId || initialState.serviceId,
      serviceSlotNumber: storedState?.serviceSlotNumber || initialState.serviceSlotNumber,
      identifyValues: storedState?.identifyValues || initialState.identifyValues,
      detail: storedState?.detail || initialState.detail,
      attributes: storedState?.attributes || initialState.attributes,
      user: storedState?.user || initialState.user,
      isRecapping: storedState?.isRecapping || initialState.isRecapping,
      isEditing: storedState?.isEditing || initialState.isEditing,
      modulePath: storedState?.modulePath || initialState.modulePath,
      appRoute: storedState?.appRoute || initialState.appRoute,
    };
  },
  mutations: {
    start(state) {
      state.isStarted = true;
    },
    setSearched(state, searched) {
      state.searched = searched;
    },
    setTopicId(state, topicId) {
      state.topicId = topicId;
    },
    setOfficeId(state, officeId) {
      state.officeId = officeId;
    },
    setSearchText(state, searchText) {
      state.searchText = searchText;
    },
    setResourceId(state, resourceId) {
      state.resourceId = resourceId;
    },
    setServiceSlotNumber(state, serviceSlotNumber) {
      state.serviceSlotNumber = serviceSlotNumber;
    },
    setIdentifyValues(state, identifyValues) {
      state.identifyValues = identifyValues;
    },
    setSearchDirectFromUrl(state, searchDirectFromUrl) {
      state.searchDirectFromUrl = searchDirectFromUrl;
    },
    setStep(state, step) {
      state.currentStep = step;
    },
    setErogationMode(state, erogationMode) {
      state.erogationMode = erogationMode;
    },
    setNumberOfReservations(state, numberOfReservations) {
      state.numberOfReservations = numberOfReservations;
    },
    setYear(state, year) {
      state.year = year;
    },
    setMonth(state, month) {
      state.month = month;
    },
    setDay(state, day) {
      state.day = day;
    },
    setHour(state, hour) {
      state.hour = hour;
    },
    setSlots(state, slots) {
      state.slots = slots;
    },
    setReservationId(state, reservationId) {
      state.reservationId = reservationId;
      state.reservationDate = reservationId
        ? new Date().toISOString()
        : undefined;
    },
    setServiceId(state, serviceId) {
      state.serviceId = serviceId;
    },
    setDetail(state, detail) {
      state.detail = detail;
    },
    setAttributes(state, attributes) {
      state.attributes = attributes;
    },
    setUser(state, user) {
      state.user = user;
    },
    patchUser(state, user) {
      state.user = { ...state.user, ...user };
    },
    setIsRecapping(state, isRecapping) {
      state.isRecapping = isRecapping;
    },
    setIsEditing(state, isEditing) {
      state.isEditing = isEditing;
    },
    setModulePath(state, modulePath) {
      state.modulePath = modulePath;
    },
  },
});
store.subscribe((mutation, state) => {
  sessionStorage.setItem("prenotazione_store", JSON.stringify(state));
});
